import Constants from '@/Constants';
import { LanguageType } from '@/models/LanguageType';
import { Person } from '@/models/Person';
import { StudentLocale } from '@/models/StudentLocale';
import http from '@/services/HttpService';
import { ApplicationState } from '@/store';
import { AxiosResponse } from 'axios';
import { call, put, select } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { updatePersonLocale } from '../identity/action';
import { getContentLocaleSuccess, setContentLocaleFailure, setContentLocaleSuccess, setLocaleFailure, setLocaleSuccess } from './action';
import { LocaleTypes } from './types';

export function* setLocaleRequest(action: PayloadAction<LocaleTypes.SET_LOCALE_REQUEST, Person>) {
    try {
        const personId: number = action.payload.id as number;
        yield call(http.post, Constants.PERSON_SET_LOCALE_URI.replace('%p', personId.toString()), action.payload);
        yield put(setLocaleSuccess(action.payload.locale));
        yield put(updatePersonLocale(action.payload.locale));
    } catch (error) {
        yield put(setLocaleFailure(error));
    }
}

export function* getContentLocaleRequest(action: PayloadAction<LocaleTypes.GET_CONTENT_LOCALE_REQUEST, StudentLocale[]>) {
    try {
        const personId: string = yield select((state: ApplicationState) => state.identity.data.person.id);

        const { data }: AxiosResponse<StudentLocale[]> = yield call(http.get, Constants.LMS_CONTENT_LOCALE_URI.replace('%p', personId));

        yield put(getContentLocaleSuccess(data.map((studentLocale) => studentLocale.locale as LanguageType)));
    } catch (error) {
        yield put(setContentLocaleFailure(error));
    }
}

export function* setContentLocaleRequest(action: PayloadAction<LocaleTypes.SET_CONTENT_LOCALE_REQUEST, StudentLocale[]>) {
    try {
        const personId: string = yield select((state: ApplicationState) => state.identity.data.person.id);

        yield call(http.put, Constants.LMS_CONTENT_LOCALE_URI.replace('%p', personId), action.payload);

        yield put(setContentLocaleSuccess(action.payload.map((studentLocale) => studentLocale.locale as LanguageType)));
    } catch (error) {
        yield put(setContentLocaleFailure(error));
    }
}
